import { render, staticRenderFns } from "./EventsEdit.vue?vue&type=template&id=28ffcfb4&"
import script from "./EventsEdit.vue?vue&type=script&lang=js&"
export * from "./EventsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports